<template>
  <div>
    <ui-toolbar :actions="toolbar"></ui-toolbar>
    <ui-cards>
      <ui-card v-for="(session, index) in $store.state.sessions" :key="index">
        <template v-slot:head>{{session.name}}</template>
        {{session.description}}
        <template v-slot:foot><a class="cursor-pointer" @click="() => $refs.editSession.open(session.id)"><i class="fal fa-edit"></i></a></template>
      </ui-card>
    </ui-cards>
  </div>
  <new-session ref="newSession" />
  <edit-session ref="editSession" />
</template>

<script>
import NewSession from "@/components/Admin/dialogs/NewSession";
import EditSession from "@/components/Admin/dialogs/EditSession";

export default {
  name: "SessionsView",
  components: {
    NewSession,
    EditSession
  },
  data(){
    return {
      event: {},
      toolbar: [
        {
          title: 'Neue Session',
          label: `<i class="fa fa-plus"></i>`,
          component: 'button',
          type: 'success',
          action: () => this.$refs.newSession.open()
        }
      ],
      options: [
        {
          value: 'value',
          label: 'label'
        }
      ]
    }
  }, created() {
    this.$store.getSessions()
  }
}
</script>

<style scoped>

</style>
